
DateParseDirective = (moment) ->
    'ngInject'

    restrict: 'A'
    require: 'ngModel'
    link: (scope, element, attrs, ngModel) ->
        format = attrs.dateParse or "LL"

        ngModel.$parsers.push (value) ->
            if not value? or value == "" then return value
            return moment(new Date(value))

        ngModel.$formatters.push (value) ->
            if moment.isMoment(value) then return value.format(format)
            else return value

        ngModel.$validators.date = (modelValue, viewValue) ->
            if not modelValue? or modelValue == "" then return true
            moment.isMoment(modelValue) and modelValue.isValid()


module.directive('dateParse', DateParseDirective)
